<template>
  <div v-show="screenWidth === 'mobile' && !isCollapsed" class="filter _hide">
    <div class="filter-short-input">
      <SearchableInput
        class="input _mobile"
        :value="filters.searchQueryMain"
        :items="items"
        @click-update="filterOnlyByName($event)"
        is-map-catering
      />
      <div
        v-if="isChangedFilterSaved"
        class="icon"
        :style="{ backgroundColor: '#FEF6E8' }"
        @click="open()"
      >
        <FilterMapIcon color="#F18E35" />
      </div>
      <div v-else class="icon" @click="open()">
        <FilterMapIcon />
      </div>
    </div>
    <div class="toggle-wrapper">
      <MainViewToggle class="toggle" out-header />
    </div>
  </div>

  <div v-show="!(screenWidth === 'mobile' && !isCollapsed)" class="filter">
    <div v-if="screenWidth === 'mobile'" class="title">
      <IconCross class="cross" @click="close" />
      <span>Фильтры</span>
    </div>

    <div v-if="screenWidth !== 'mobile'" class="input-search">
      <SearchableInput
        class="input"
        :value="filters.searchQuery"
        :items="items"
        is-map-catering
        @click-update="filterOnlyByName($event)"
      />
    </div>

    <div v-if="screenWidth !== 'mobile'" class="filter-title">
      Поиск по фильтрам
    </div>

    <perfect-scrollbar
      @ps-y-reach-end="onScrollEventEnd"
      @ps-y-reach-start="onScrollEventStart"
      class="filter-wrapper"
    >
      <VAccordion disabled class="accordion">
        <template #head>Кухня</template>
        <template #body>
          <div class="filterButtons">
            <BooleanFilter
              v-for="kitchen in currentKitchens"
              :value="filters.cuisineId.includes(kitchen.id)"
              @change="updateFilter('cuisine', kitchen.id)"
              :key="kitchen.id"
            >
              {{ kitchen.name }}
            </BooleanFilter>
            <BooleanFilter
              v-if="!isMoreKitchens"
              @click="isMoreKitchens = true"
              key="more"
              is-more
            >
              Другие кухни...
            </BooleanFilter>
          </div>
        </template>
      </VAccordion>

      <div class="checkboxes">
        <Checkbox
          :value="filters.availableBooking"
          @update:value="updateFilter('availableBooking', $event ? 1 : 0)"
          label="Доступно онлайн бронирование"
          optionName="availableBooking"
          class="checkbox"
        />

        <Checkbox
          :value="filters.now"
          @update:value="updateFilter('now', $event ? 1 : 0)"
          label="Открыто сейчас"
          optionName="now"
          class="checkbox"
        />

        <Checkbox
          :value="filters.breakfast"
          @update:value="updateFilter('breakfast', $event ? 1 : 0)"
          label="Завтраки"
          optionName="breakfast"
          class="checkbox"
        />

        <Checkbox
          :value="filters.lunch"
          @update:value="updateFilter('lunch', $event ? 1 : 0)"
          label="Бизнес-ланчи"
          optionName="lunch"
          class="checkbox"
        />
      </div>

      <VAccordion disabled class="accordion">
        <template #head>Особенности</template>
        <template #body>
          <div class="filterButtons">
            <BooleanFilter
              v-for="feature in currentFeatures"
              :value="filters.featureId.includes(feature.id)"
              @change="updateFilter('feature', feature.id)"
              :key="feature.id"
            >
              {{ feature.name }}
            </BooleanFilter>
            <BooleanFilter
              v-if="!isMoreFeatures"
              @click="isMoreFeatures = true"
              key="more"
              is-more
            >
              Другие особенности...
            </BooleanFilter>
          </div>
        </template>
      </VAccordion>

      <VAccordion disabled class="accordion">
        <template #head>Тип заведения</template>
        <template #body>
          <div class="types">
            <Checkbox
              :value="filters.types.includes(2)"
              @update:value="updateFilter('types', 2)"
              label="Ресторан"
              optionName="restaurant"
              class="checkbox _type"
            />

            <Checkbox
              :value="filters.types.includes(1)"
              @update:value="updateFilter('types', 1)"
              label="Бар"
              optionName="bar"
              class="checkbox _type"
            />

            <Checkbox
              :value="filters.types.includes(3)"
              @update:value="updateFilter('types', 3)"
              label="Кафе"
              optionName="cafe"
              class="checkbox _type"
            />

            <Checkbox
              :value="filters.types.includes(5)"
              @update:value="updateFilter('types', 5)"
              label="Столовая"
              optionName="cafeteria"
              class="checkbox _type"
            />

            <Checkbox
              :value="filters.types.includes(4)"
              @update:value="updateFilter('types', 4)"
              label="Закусочная"
              optionName="diner"
              class="checkbox _type"
            />

            <Checkbox
              :value="filters.types.includes(6)"
              @update:value="updateFilter('types', 6)"
              label="Кальянная"
              optionName="hookah"
              class="checkbox _type"
            />
          </div>
        </template>
      </VAccordion>

      <VAccordion>
        <template #head>Рейтинг</template>
        <template #body>
          <div class="rating">
            <InputStar
              @update:value="updateFilter('rating', $event)"
              :modelValue="filters.rating"
            />
            <span v-if="filters.rating">{{ filters.rating }} и более</span>
            <span v-else>Любой</span>
          </div>
        </template>
      </VAccordion>

      <VAccordion v-if="screenWidth !== 'mobile'" range>
        <template #head>Средний чек, ₽</template>
        <template #body>
          <VRange
            is-double
            :value-range="filters.averageCheck"
            :value-max="10000"
            :merge="500"
            format-marker="₽"
            is-values
            type="averageCheck"
            :filters="filters"
            @capacity="$emit('averageCheck', $event)"
            @averageCheck="$emit('averageCheck', $event)"
            @on-change="updateFilter('averageCheck', $event)"
          />
        </template>
      </VAccordion>

      <div v-else class="range-wrapper">
        <div class="table">
          <span>Средний чек, ₽</span>
          <div class="range-table">
            <VInput
              type="number"
              disableActiveAndFocus
              class="range-input"
              :value="filters.averageCheck[0].toString()"
              @update:value="
                updateFilter('averageCheck', [+$event, filters.averageCheck[1]])
              "
            />
            <VInput
              type="number"
              disableActiveAndFocus
              class="range-input"
              :value="filters.averageCheck[1]"
              @update:value="
                updateFilter('averageCheck', [filters.averageCheck[0], +$event])
              "
            />
          </div>
        </div>
        <VRange
          :value-range="filters.averageCheck"
          :value-max="10000"
          :merge="500"
          :tooltips="false"
          @on-change="updateFilter('averageCheck', $event)"
          is-double
        />
      </div>

      <VAccordion v-if="screenWidth !== 'mobile'" class="accordion_last" range>
        <template #head>Вместимость</template>
        <template #body>
          <VRange
            :value-range="filters.capacity"
            :value-max="250"
            :merge="20"
            is-double
            is-values
            type="capacity"
            :filters="filters"
            @capacity="$emit('update', $event)"
            @averageCheck="$emit('update', $event)"
            @on-change="updateFilter('capacity', $event)"
          />
        </template>
      </VAccordion>

      <div v-else class="range-wrapper accordion_last">
        <div class="table">
          <span>Вместимость</span>
          <div class="range-table">
            <VInput
              type="number"
              disableActiveAndFocus
              class="range-input"
              :value="filters.capacity[0].toString()"
              @update:value="
                updateFilter('capacity', [+$event, filters.capacity[1]])
              "
            />
            <VInput
              type="number"
              disableActiveAndFocus
              class="range-input"
              :value="filters.capacity[1]"
              @update:value="
                updateFilter('capacity', [filters.capacity[0], +$event])
              "
            />
          </div>
        </div>
        <VRange
          :value-range="filters.capacity"
          :value-max="250"
          :merge="20"
          :tooltips="false"
          is-double
          @on-change="updateFilter('capacity', $event)"
        />
      </div>
    </perfect-scrollbar>

    <div class="btns">
      <VButton
        :small="screenWidth === 'desktop'"
        class="btn"
        outline
        @click="reset"
        :disabled="!isChangedFilterSaved"
      >
        Сбросить все
      </VButton>

      <VButton class="btn _accept" @click="save">Применить</VButton>
    </div>
  </div>
</template>

<script>
import SearchableInput from "@/components/ui/SearchableInput.vue";
import VButton from "@/components/ui/VButton.vue";
import VAccordion from "@/components/ui/VAccordion.vue";
import BooleanFilter from "@/components/ui/BooleanFilter.vue";
import VRange from "@/components/ui/VRange.vue";
import { CUISINES_SORTED, FEATURES_SORTED } from "@/assets/js/utils/consts";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import IconCross from "@/components/icons/IconCross.vue";
import { getDate } from "@/assets/js/utils/helpers";
import Checkbox from "@/components/ui/Checkbox.vue";
import FilterMapIcon from "@/components/icons/FilterMapIcon.vue";
import VInput from "@/components/ui/VInput.vue";
import InputStar from "@/components/ui/InputStar.vue";
import MainViewToggle from "@/components/pages/home/MainViewToggle.vue";

export default {
  name: "VClientFilter",
  components: {
    MainViewToggle,
    InputStar,
    VInput,
    FilterMapIcon,
    Checkbox,
    IconCross,
    VRange,
    VButton,
    SearchableInput,
    VAccordion,
    BooleanFilter,
    PerfectScrollbar,
  },

  props: {
    cateringPage: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      kitchens: CUISINES_SORTED,
      features: FEATURES_SORTED,
      isMoreKitchens: false,
      isMoreFeatures: false,
      isHovered: false,
    };
  },

  methods: {
    filterOnlyByName(value) {
      this.$store.dispatch("filterOnlyByName", { value });
    },
    updateFilter(type, value) {
      this.$store.dispatch("setRestaurantFilter", {
        value,
        type,
      });
    },
    onScrollEventStart() {
      if (this.screenWidth === "mobile") {
        return;
      }
      this.$store.commit({ type: "setIsFooter", value: false });
    },
    onScrollEventEnd() {
      if (this.screenWidth === "mobile") {
        return;
      }
      this.$store.commit({ type: "setIsFooter", value: true });
    },
    getDate(value) {
      return getDate(value, true);
    },
    close() {
      this.$store.commit({ type: "setIsCollapsed", value: false });
    },
    open() {
      this.$store.commit({ type: "setIsCollapsed", value: true });
    },
    reset() {
      this.$store.dispatch("resetFilter");
      this.$store.dispatch("getClientRestaurants", {
        value: { city: this.$store.state.general.city.city, settlement: "" },
      });
    },
    save() {
      this.$store.dispatch("setRestaurantFilter", {
        value: "",
        type: "query",
      });
      this.$store.dispatch("filterRestaurants");
      this.close();
    },
  },

  computed: {
    items() {
      return this.$store.state.clientRestaurants.items;
    },
    filters() {
      return this.$store.state.clientRestaurants.restaurantFilter;
    },
    isChangedFilterSaved() {
      return this.$store.state.clientRestaurants.isChangedFilter;
    },
    isCollapsed() {
      return this.$store.state.clientRestaurants.isCollapsed;
    },
    filterTime() {
      return this.$store.state.general.filterTime;
    },
    currentKitchens() {
      if (!this.isMoreKitchens) {
        return this.kitchens.slice(0, 6);
      } else {
        return this.kitchens;
      }
    },
    currentFeatures() {
      if (!this.isMoreFeatures) {
        return this.features.slice(0, 6);
      } else {
        return this.features;
      }
    },
    screenWidth() {
      return this.$store.getters.screenType;
    },
  },
};
</script>

<style scoped lang="scss">
.filter {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  width: 320px;
  min-width: 320px;
  height: 100%;
  padding-top: 24px;
  background-color: #fff;
  z-index: 1111;

  @include mobile {
    width: 100%;
    min-width: auto;
    padding-top: 0;
    z-index: 1111111111;

    .accordion {
      &:first-child {
        margin-top: 64px;
      }

      &_last {
        margin-bottom: 36px;
      }
    }
  }

  &._hide {
    top: 0;
    height: auto;
    padding: 16px 16px 0;
    width: 100%;
    min-width: auto;
    background-color: transparent;

    .filter-short-input {
      margin-bottom: 0;
    }
  }

  & > div {
    margin-bottom: 24px;
  }

  .btns {
    margin-bottom: 0;
  }

  .accordion_last {
    margin-bottom: 170px;
  }
}

.input-search {
  padding: 0 24px;
}

.input {
  &._number {
    width: 100%;
  }

  &._mobile {
    width: 100%;
    margin-bottom: 16px;
  }
}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  padding: 0 24px;
}

.btns {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 320px;
  background-color: white;
  z-index: 5;
  padding: 24px 16px 32px 16px;

  @include mobile {
    width: 100%;
  }
}

.btn {
  width: 111px;

  &:first-child {
    margin-bottom: 24px;
  }

  @include mobile {
    width: 100%;
  }

  &._accept {
    width: 100%;
  }
}

.filterButtons {
  display: flex;
  flex-wrap: wrap;

  & > div {
    width: auto;
    margin-bottom: 12px;
  }

  & > div:not(:last-child) {
    margin-right: 12px;

    @include mobile {
      margin-right: 8px;
    }
  }
}

.more {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #f18e35;
  cursor: pointer;
}

.title {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 64px;
  background-color: #ffffff;
  position: fixed;
  z-index: 100;
  width: calc(100% - 48px);

  span {
    font-family: $font-family-secondary;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
  }

  svg {
    cursor: pointer;
  }

  @include mobile {
    padding-left: 24px;
  }
}

.select {
  width: 100%;
}

.button-date {
  display: flex;
  flex-direction: column;
  width: 100%;

  &._date {
    width: 210px;
  }

  &._time {
    width: 98px;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    margin-bottom: 4px;
  }

  div {
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    cursor: pointer;
    padding: 9px 12px;
    border: 1px solid #d6d6d6;
    border-radius: 8px;
  }
}

.checkbox {
  padding: 0;

  &._type {
    width: auto;
  }
}

.filter-title {
  padding-left: 24px;
  margin-bottom: 32px;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: #f18e35;
  user-select: none;
}

.checkboxes {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-short-input {
  display: flex;
  gap: 8px;
  width: 100%;
  height: 64px;
  padding: 8px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 4px 16px 0 #00000014;

  .icon {
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background-color: #f6f6f6;
  }
}

.range-table {
  display: flex;
  height: 40px;
  width: 180px;
  border: 1px solid #d6d6d6;
  border-radius: 8px;

  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    height: 100%;

    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
  }

  div:last-child {
    border-left: 1px solid #d6d6d6;
  }
}

.table {
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 28px;
}

.range-input {
  font-size: 12px;

  &:first-child {
    border-radius: 8px 0 0 8px;
  }

  &:nth-child(2) {
    border-radius: 0 8px 8px 0;
  }
}

.rating {
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;

  :deep(.stars) {
    gap: 2px;

    svg {
      cursor: pointer;
      height: 24px;
      width: 24px;
    }
  }
}

.toggle-wrapper {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 92px;
  left: 0;
  width: 100%;
}

.toggle {
  width: 328px;
  &:deep(.wrapper) {
    box-shadow: 0 4px 16px 0 #00000014;
  }
}

.types {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
</style>
